import React from 'react';

import {SkeletonItem} from 'src/components/skeleton';

import {FormSection} from '@pb/kit-component-form-section';
import {Group, Item} from '@pb/kit-component-group';


const UsersSectionSkeletonItem = () => (
    <Group gap="l">
        <Item style={{width: 150}}>
            <SkeletonItem width={90} height={17}/>
        </Item>
        <SkeletonItem width={11} height={17}/>
    </Group>
);

export const UsersSectionSkeleton = () => (
    <FormSection
        headline="Users"
        info={() => (
            <Item grow={1}>
                <Group justify="space-between">
                    <SkeletonItem width={55} height={28}/>
                    <SkeletonItem width={90} height={32}/>
                </Group>
            </Item>
        )}>
        <Group justify="space-between">
            <Group direction="v" alignItems="start">
                <UsersSectionSkeletonItem/>
                <UsersSectionSkeletonItem/>
                <UsersSectionSkeletonItem/>
                <UsersSectionSkeletonItem/>
                <UsersSectionSkeletonItem/>
            </Group>
            <Group direction="v" alignItems="start">
                <UsersSectionSkeletonItem/>
                <UsersSectionSkeletonItem/>
                <UsersSectionSkeletonItem/>
                <UsersSectionSkeletonItem/>
                <UsersSectionSkeletonItem/>
            </Group>
        </Group>
    </FormSection>
);
